import { InputBase, NativeSelect } from "@mui/material";
import * as React from "react";
import { styled, useTheme } from "@mui/material/styles";

//選擇產品的下拉選單 (Product, Bundle, OST)
export default function SimpleSelect({
  name,
  options,
  texts,
  value,
  onBlur,
  onChange,
  style,
  id,
  disabled,
}: {
  id?: string;
  name?: string;
  postfix?: string;
  options: string[] | number[];
  texts?: string[];
  value: string | number;
  style?: React.CSSProperties;
  disabled?: boolean;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  onChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
}) {
  // console.log("SimpleSelect", value);

  const theme = useTheme();

  const BootstrapInput = styled(InputBase)({
    // root: {
    //   "label + &": {
    //     marginTop: theme.spacing(3)
    //   }
    // },
    "& .MuiInputBase-input": {
      borderRadius: 4,
      position: "relative",
      width: "100%",
      // backgroundColor: theme.palette.background.paper,
      backgroundColor: "transparent",
      border: "1px solid #ced4da",
      fontSize: 16,
      padding: "10px 26px 10px 12px",
      // transition: "",
      transition: theme.transitions.create(["border-color", "box-shadow"]),
      // Use the system font instead of the default Roboto font.
      fontFamily: [
        "-apple-system",
        "BlinkMacSystemFont",
        '"Segoe UI"',
        "Roboto",
        '"Helvetica Neue"',
        "Arial",
        "sans-serif",
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(","),
      "&:focus": {
        borderRadius: 4,
        borderColor: "#80bdff",
        boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)",
      },
    },
  });
  // const numberOptions = options as number[];
  // const stringOptions = options as string[];
  // console.log("Number Opt", numberOptions);
  const defaultStyle = Object.assign(
    {
      position: "relative",
      // transition: theme.transitions.create(["border-color", "box-shadow"]),
      borderRadius: 4,
      marginRight: 6,
      border: "1px solid #ced4da",
      fontSize: 16,
      padding: "10px 26px 10px 12px",
    },
    style
  );

  return (
    <NativeSelect
      id={id}
      disabled={disabled}
      name={name}
      variant="outlined"
      // defaultValue=""
      style={defaultStyle}
      input={<InputBase></InputBase>}
      // defaultValue=""
      className="form-control"
      onChange={(evt) => {
        const v = evt.target.value;
        console.log("SimpleSelect OnChange", v);

        onChange(evt);
      }}
      onBlur={onBlur}
      value={value}
    >
      {typeof options[0] == "string" &&
        (options as string[]).map((value, index) => {
          return (
            <option
              disabled={value == "" || value == null}
              // hidden={value == "" || value == null}
              key={value}
              value={value}
            >
              {texts == null ? value : texts[index]}
            </option>
          );
        })}
      {typeof options[0] == "number" &&
        (options as number[]).map((value, index) => {
          return (
            <option
              disabled={value == null}
              hidden={value == null}
              key={value}
              value={value}
            >
              {texts == null ? value : texts[index]}
            </option>
          );
        })}
      {/* <option value="" disabled hidden></option> */}
    </NativeSelect>
  );

  // else if (stringOptions)
  //   return (
  //     <NativeSelect
  //       style={{ width: "100%", marginRight: 24 }}
  //       input={<BootstrapInput style={{ width: "100%" }}></BootstrapInput>}
  //       id="expMonth"
  //       // defaultValue=""
  //       className="form-control"
  //       onChange={(evt) => {
  //         onChange(evt);
  //         //.target.value
  //         // checkout.setExpMonth(evt.target.value);
  //       }}
  //       value={value}
  //     >
  //       <option value="" disabled hidden></option>
  //       {stringOptions.map((value, index) => {
  //         return (
  //           <option key={value} value={value}>
  //             {texts == null ? value : texts[index]}
  //           </option>
  //         );
  //       })}
  //     </NativeSelect>
  //   );
}
